import { cn } from '@/lib/utils';

interface GalexiaLogoProps {
  className?: string;
  size?: number;
}

export function GalexiaLogo({ className, size = 32 }: GalexiaLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('shrink-0', className)}
    >
      <defs>
        <linearGradient id="galexia-grad" x1="10" y1="10" x2="90" y2="90" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#4A6CF7" />
          <stop offset="45%" stopColor="#8B5CF6" />
          <stop offset="100%" stopColor="#06B6D4" />
        </linearGradient>
      </defs>
      {/* Soft halo */}
      <path
        d="M50 6 L56 42 L88 22 L58 46 L94 50 L58 54 L88 78 L56 58 L50 94 L44 58 L12 78 L42 54 L6 50 L42 46 L12 22 L44 42 Z"
        fill="url(#galexia-grad)"
        opacity="0.05"
      />
      {/* Outer star */}
      <path
        d="M50 14 L54 44 L80 30 L56 48 L88 50 L56 52 L80 72 L54 56 L50 86 L46 56 L20 72 L44 52 L12 50 L44 48 L20 30 L46 44 Z"
        stroke="url(#galexia-grad)"
        strokeWidth="1.6"
        fill="none"
        strokeLinejoin="round"
      />
      {/* Inner star rotated 22.5deg */}
      <g transform="rotate(22.5, 50, 50)" opacity="0.4">
        <path
          d="M50 26 L52.5 45 L68 35 L55 47.5 L75 50 L55 52.5 L68 65 L52.5 55 L50 74 L47.5 55 L32 65 L45 52.5 L25 50 L45 47.5 L32 35 L47.5 45 Z"
          stroke="url(#galexia-grad)"
          strokeWidth="1.2"
          fill="none"
          strokeLinejoin="round"
        />
      </g>
      {/* Tip dots */}
      <circle cx="50" cy="14" r="1.5" fill="url(#galexia-grad)" opacity="0.6" />
      <circle cx="80" cy="30" r="1.5" fill="url(#galexia-grad)" opacity="0.6" />
      <circle cx="88" cy="50" r="1.5" fill="url(#galexia-grad)" opacity="0.6" />
      <circle cx="80" cy="72" r="1.5" fill="url(#galexia-grad)" opacity="0.6" />
      <circle cx="50" cy="86" r="1.5" fill="url(#galexia-grad)" opacity="0.6" />
      <circle cx="20" cy="72" r="1.5" fill="url(#galexia-grad)" opacity="0.6" />
      <circle cx="12" cy="50" r="1.5" fill="url(#galexia-grad)" opacity="0.6" />
      <circle cx="20" cy="30" r="1.5" fill="url(#galexia-grad)" opacity="0.6" />
      {/* Core */}
      <circle cx="50" cy="50" r="9" fill="url(#galexia-grad)" opacity="0.12" />
      <circle cx="50" cy="50" r="6" fill="url(#galexia-grad)" />
      <circle cx="50" cy="50" r="2.8" fill="var(--background)" />
    </svg>
  );
}
